module.exports = __webpack_public_path__ + "img/play-icon.b3003a22.png";